import React, { Component } from "react"
import TableContratadosTrash from "./TableContratadosTrash"
import Layout from "../Layout"
import { Loading, HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
export default class ContratadosTrash extends Component {
  constructor() {
    super()
    this.getContratados = this.getContratados.bind(this)
    this.didRestore = this.didRestore.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { contratados: [], initialContratados: [], showTable: false }
  }
  componentWillMount() {
    this.getContratados()
  }

  getContratados() {
    ApiHelper.getContratadosTrash((contratados, error) => {
      if (contratados) {
        this.setState({
          contratados: contratados,
          initialContratados: contratados,
          showTable: true
        })
      } else {
        this.setState({ httpError: error })
      }
    })
  }
  didRestore() {
    this.getContratados()
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialContratados.filter(contratado => {
      return (
        contratado.nome_razao_social.toLowerCase().search(searchText) !== -1 ||
        contratado.rua.toLowerCase().search(searchText) !== -1 ||
        contratado.cpf_cnpj.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      contratados: filtered
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Contratados">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Contratados">
        {this.state.showTable ? (
          <TableContratadosTrash
            filter={this.filter}
            onRestore={this.didRestore}
            sizeClass=""
            title="Contratados deletados"
            subtitle="Listagem de todos os fornecedores deletados"
            backgroundColor="as-blue"
            rows={this.state.contratados}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/contratados/ContratadosTrash.js